import { useTranslation } from "react-i18next";

import styles from "./Topbar.module.css";
import { useBreadcrumbs } from "./useBreadcrumbs";

import { IconButtonV2 } from "@/components/atoms/IconButton";
import { Breadcrumb } from "@/components/molecules/Breadcrumb";

interface Props {
  isCollapsed: boolean;
  onToggleCollapse: () => void;
}

export const Topbar = ({ isCollapsed, onToggleCollapse }: Props) => {
  const { t } = useTranslation();
  const breadcrumbs = useBreadcrumbs();

  return (
    <header className={styles.topbar}>
      <IconButtonV2
        icon="collapse"
        size="sm"
        aria-label={
          isCollapsed ? t("topbar.expandMenu") : t("topbar.collapseMenu")
        }
        onClick={onToggleCollapse}
      />
      {breadcrumbs.length > 0 && (
        <Breadcrumb aria-label={t("topbar.breadcrumb")} items={breadcrumbs} />
      )}
    </header>
  );
};
